// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1dlMW","selected":"Chip_selected__15NIo"};